export const CMS_SECTION_IDS = {
  ATCC: 'ATCC',
  CALLOUT_MAKE: 'idCalloutMake',
  CALLOUT_MODEL: 'idCalloutMode',
  CALLOUT_YEAR: 'idCalloutYear',
  DEALS: 'Deals',
  DTCC: 'DTCC',
  SHOP_BY_OTHER: 'FEATURED CATEGORIES, LOWEST PRICES'
};

export const CREDIT_CARD_STYLE_SECTION_NAME = 'vlp-dtcc-style';

export const META_TAG_NAMES = {
  META_TITLE: 'title'
};

export const FITMENT_RESULTS_CATEGORY = {
  FITMENT_ACCESSORIES: 'accessories',
  FITMENT_PACKAGES: 'packages',
  FITMENT_TIRES: 'tires',
  FITMENT_WHEELS: 'wheels'
};

export const CATEGORY_MAP = {
  accessories: 'ACCESSORIES',
  packages: 'WHEEL & TIRE PACKAGES',
  tires: 'TIRES',
  wheels: 'WHEELS'
};

export const CMS_CONTROLLED_TEXT_IDS = {
  fitmentContinueCta: 'fitment-continue-CTAButton',
  fitmentRecommendedResultsCta: 'fitment-recommendedresults-CTAButton',
  fitmentShopAllAccessoriesCta: 'fitment-shopallaccessories-CTAButton',
  fitmentShopAllPackagesCta: 'fitment-shopallpackages-CTAButton',
  fitmentShopAllTiresCta: 'fitment-shopalltires-CTAButton',
  fitmentShopAllTiresLink: 'fitment-shopalltires-link',
  fitmentShopAllWheelsCta: 'fitment-shopallwheels-CTAButton',
  fitmentTireGuideLink: 'fitment-tireguide-link'
};
